<div >
  <div class="header">
    <h2 style="margin: 0 auto; padding-left: 25%">
        Upload {{getUploadType()}}
    </h2>

    <div>
      <button *ngIf="data.type.includes('upload')"
              mat-mini-fab
              color="primary"
              (click)="onSend()">
        <mat-icon>file_upload</mat-icon>
      </button>
      <button *ngIf="data.type === 'email'"
              mat-mini-fab
              color="primary"
              (click)="onSend()">
        <mat-icon>mail</mat-icon>
      </button>
    </div>
    <button mat-mini-fab color="basic" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="divider"><mat-divider></mat-divider></div>

  <ng-template [ngIf]="data.type === 'email'">
    <mat-form-field class="w-100" appearance="fill">
      <input matInput
             placeholder="portal@email.com"
             [value]="email"
             type="email"/>
    </mat-form-field>
  </ng-template>

<!-- DRAG n DROP Docs https://valor-software.com/ng2-file-upload/ -->
  <ng-template [ngIf]="data.type.includes('upload')">
    <div class="w-100">
      <div ng2FileDrop
          *ngIf="file === undefined"
          [ngClass]="{'drop-zone-file-over': hasBaseDropZoneOver}"
          (fileOver)="fileOverBase($event)"
          class="drop-zone drop-zone-border">
          <div style="color: lightgray; text-align: center"
               (drop)="onFile($event); $event.preventDefault()">
            <h2>Drag & Drop file</h2>
            <h2>or</h2>
            <input type="file"
                   style="padding-left: 14%"
                   (change)="onFile($event)"
                   placeholder="Upload file"
                   accept=".pdf,.doc,.docx,.csv,.txt,.xls,.xlsx,.gif,.">
          </div>
      </div>
      <div *ngIf="file !== undefined" class="d-flex flex-column file-preview">
        <div>
          <mat-icon class="file-icon-size">insert_drive_file</mat-icon>
        </div>
        <p>
          {{file.name}}
        </p>
        <button mat-icon-button color="warn" (click)="deleteFile()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="divider"><mat-divider></mat-divider></div>
</div>
